import { useCallback, useEffect, useState } from "react";
import { WasherCard } from "../components/WasherCard";
import { ReviewDialog } from "../components/ReviewDialog";
import { QrDialog } from "../components/QrDialog";
import axios, { API } from "../lib/api";

const HERO = "https://images.unsplash.com/photo-1616804087352-0d82fc0c37bf?crop=entropy&cs=srgb&fm=jpg&q=80&w=1800";

export default function Home() {
  const [washers, setWashers] = useState(null);
  const [reviewFor, setReviewFor] = useState(null);
  const [qrFor, setQrFor] = useState(null);

  const load = useCallback(() => axios.get(`${API}/washers`).then((r) => setWashers(r.data)), []);
  useEffect(() => { load(); }, [load]);

  return (
    <main>
      <section className="relative overflow-hidden border-b border-white/5">
        <img src={HERO} alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B1017] via-[#0B1017]/80 to-[#0B1017]/30" />
        <div className="relative mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-28">
          <p className="rise text-xs font-medium uppercase tracking-[0.25em] text-[#00F0FF]">Echipa noastră</p>
          <h1 className="rise mt-4 max-w-2xl font-display text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl"
            style={{ animationDelay: "80ms" }}>
            Cine ți-a spălat mașina azi?
          </h1>
          <p className="rise mt-5 max-w-lg text-base text-slate-300 md:text-lg" style={{ animationDelay: "160ms" }}>
            Alege spălătorul și spune-ne cum a fost. Durează 20 de secunde și nu ai nevoie de cont.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-20">
        {washers === null ? (
          <p className="text-slate-500" data-testid="washers-loading">Se încarcă echipa…</p>
        ) : washers.length === 0 ? (
          <p className="text-slate-400" data-testid="washers-empty">Momentan nu există spălători afișați.</p>
        ) : (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 sm:gap-8" data-testid="washers-grid">
            {washers.map((w, i) => (
              <WasherCard key={w.id} washer={w} index={i} onReview={setReviewFor} onQr={setQrFor} />
            ))}
          </div>
        )}
      </section>

      <ReviewDialog washer={reviewFor} open={!!reviewFor} onOpenChange={(o) => !o && setReviewFor(null)} onDone={load} />
      <QrDialog washer={qrFor} open={!!qrFor} onOpenChange={(o) => !o && setQrFor(null)} />
    </main>
  );
}
